import { getState } from './state';
import { createSelector } from 'reselect';
export const getMessageState = createSelector([
    (state)=>{
        var _getState_messageState;
        return (_getState_messageState = getState(state).messageState) !== null && _getState_messageState !== void 0 ? _getState_messageState : {};
    },
    (state, messageId)=>messageId
], (messageState, messageId)=>{
    return messageState[messageId] || {};
});

//# sourceMappingURL=messageStates.js.map